import { render } from "./SendBid.vue?vue&type=template&id=b52a509c"
import script from "./SendBid.vue?vue&type=script&lang=js"
export * from "./SendBid.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./SendBid.vue?vue&type=style&index=0&id=b52a509c&lang=scss&module=true"
cssModules["$style"] = style0

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__